import { businessKey } from 'queryKeys';

export const PLAYGROUND = 'playground';
const pgQuery = businessKey.query(PLAYGROUND);

const MUTATION_REQ1 = 'req1';
const MUTATION_REQ2 = 'req2';
const MUTATION_REQ3 = 'req3';
const MUTATION_REQ4 = 'req4';
const MUTATION_REQ5 = 'req5';
const MUTATION_500 = '500';
const MUTATION_INTERNAL_ERROR = 'internal-error';
const MUTATION_ECONNRESET = 'econnreset';
const MUTATION_CANCELATION_STORM = 'cancelationStorm';
const MUTATION_INTERNAL_ERROR_500_LONG = 'internalError500Long';
export const details = pgQuery.details();
export const model = pgQuery.exact();

export const grids = pgQuery.grids();
export const grid = pgQuery.grid();

export const mutations = pgQuery.mutations();
export const create = mutations.create();
export const edit = mutations.update();

export const internalError = mutations.mutate(MUTATION_INTERNAL_ERROR);
export const req1 = mutations.mutate(MUTATION_REQ1);
export const req2 = mutations.mutate(MUTATION_REQ2);
export const req3 = mutations.mutate(MUTATION_REQ3);
export const req4 = mutations.mutate(MUTATION_REQ4);
export const req5 = mutations.mutate(MUTATION_REQ5);
export const m500 = mutations.mutate(MUTATION_500);
export const econnreset = mutations.mutate(MUTATION_ECONNRESET);
export const cancelationStorm = mutations.mutate(MUTATION_CANCELATION_STORM);
export const internalError500Long = mutations.mutate(
  MUTATION_INTERNAL_ERROR_500_LONG
);
